import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, Progress, TitleHeader } from 'web-library';
import { useHistory } from 'react-router-dom';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import NotificationReportDetails from '../../modules/admin/components/NotificationReportDetails';
import RouteKey from '../../routes/key';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const NotificationReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: authorities, isLoading: isLoadingAuthorities } = useGetUserAuthorities();

  useEffect(() => {
    if (isLoadingAuthorities) {
      setHasView(false);
    } else if (
      !isLoadingAuthorities &&
      !authorities?.includes(AUTHORITY_NAMES.CP_ADMIN_NOTIFICATION_REPORT_VIEW)
    ) {
      setHasView(false);
      history.push(`/${error}/${generic}`);
    } else setHasView(true);
  }, [history, authorities, isLoadingAuthorities]);

  return (
    <>
      <TitleHeader title={t('admin->>NotificationReport.NotificationHeader.NotificationReport')} />
      {!isLoadingAuthorities && hasView ? (
        <NotificationReportDetails />
      ) : (
        <ContentTemplate>
          <Progress size="XL" color="secondary" />
        </ContentTemplate>
      )}
    </>
  );
};

export default NotificationReport;
